import { render, staticRenderFns } from "./ShiftsEntity.vue?vue&type=template&id=41e2ed48&"
import script from "./ShiftsEntity.vue?vue&type=script&lang=js&"
export * from "./ShiftsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports